export default {
    'rnb-timing-fast': '250ms',
    'rnb-timing-normal': '500ms',
    'rnb-timing-slow': '1000ms',
    'rnb-timing-easing-in': 'cubic-bezier(0.4, 0, 1, 1)',
};
